import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import { generateEntityWithChildIds } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createContactUs(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): ContactUsInterface {
  return {
    ...generateEntityWithChildIds(
      EntityTypeEnum.ContactUs,
      parentId,
      masterBlockId,
    ),
    padding: {
      paddingTop: 30,
      paddingRight: 70,
      paddingBottom: 30,
      paddingLeft: 70,
    },
    mobilePadding: {
      paddingTop: 10,
      paddingRight: 20,
      paddingBottom: 10,
      paddingLeft: 20,
    },
  }
}
